module.exports = __webpack_public_path__ + "img/30_24.899f1942.png";